import {
  get,
  post
} from '../axios'

class Customer {
  async getCustomerList(param) {
    const res = await get('/Customer/GetCustomerListByKeyWord', param)
    return res
  }
  async getCustomerConnecterList(param) {
    const res = await get('/Customer/GetConnecterByCustId', param)
    return res
  }
  async getCustomerInBranchs(param) {
    const res = await get('/Customer/GetCustomerListByBranchs', param)
    return res
  }
  async GetCustomerListByKeyWordUnLimit(param) {
    const res = await get('/Customer/GetCustomerListByKeyWordUnLimit', param)
    return res
  }
  async addCustomer(data,param) {
    const res = await post('/Customer/AddCustomer',data,param)
    return res
  }
  async approvedCustomer(data,param) {
    const res = await post('/Customer/ApproveCustomer',data,param)
    return res
  }
  async getCustomerById(param) {
    const res = await get('/Customer/GetCustomerByid', param)
    return res
  }
}
export default new Customer()